import { render, staticRenderFns } from "./Intention.vue?vue&type=template&id=cc460caa&"
import script from "./Intention.vue?vue&type=script&lang=js&"
export * from "./Intention.vue?vue&type=script&lang=js&"
import style0 from "./Intention.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports